// extracted by mini-css-extract-plugin
export var active = "by_bd";
export var categories = "by_cG";
export var category = "by_cH";
export var icon = "by_bw";
export var icons = "by_bt";
export var image = "by_k";
export var member = "by_fT";
export var memberTitle = "by_fV";
export var name = "by_fy";
export var placeholder = "by_bb";
export var section = "by_j";
export var show = "by_L";
export var subtitle = "by_cR";
export var team = "by_fS";